import React from 'react';

export function TableHeader({ width, children }: { width?: string; children?: React.ReactNode }) {
    return <th className={`border p-1 ${width || ''} text-xs text-left`}>{children}</th>;
}
